export const SITE = {
  name: "Empire Aluminium Windows",
  legalName: "Empire Facade Group Ltd",
  phone: "07400 000613",
  phoneHref: "tel:+447400000613",
  email: "info@empirealu.uk",
  address: {
    line1: "Unit 3 Northgate Industrial Estate",
    line2: "Collier Row Road",
    town: "Romford",
    postcode: "RM5 2BG",
    country: "United Kingdom",
  },
  hours: "Mon – Fri: 9:00am – 5:30pm",
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_empire-aluminium/artifacts/0fnob3et_Empire%20aluminium%20windows.png",
};

export const IMAGES = {
  heroBifold: "https://images.unsplash.com/photo-1758998202918-d921125a700f?q=80&w=1920&auto=format&fit=crop",
  modernWindows: "https://images.unsplash.com/photo-1766603636700-e9d80473f40f?q=80&w=1600&auto=format&fit=crop",
  glassFront: "https://images.unsplash.com/photo-1652400095202-4569b8489d00?q=80&w=1600&auto=format&fit=crop",
  welder: "https://images.unsplash.com/photo-1598302936625-6075fbd98dd7?q=80&w=1600&auto=format&fit=crop",
  machinery: "https://images.unsplash.com/photo-1598299803204-b73796f43289?q=80&w=1600&auto=format&fit=crop",
  metalTexture: "https://images.unsplash.com/photo-1667892702884-faa077e80d7b?q=80&w=1600&auto=format&fit=crop",
  casement: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/f049d8df2705c738d0b74de6147484043868ebb65252146c2da22c357c8ddea5.jpeg",
  sash: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/c22530dd28cdc7dc654ab26e5697ed9b091e6135f4109f5bdf724f01cf9e70c6.jpeg",
  partitions: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/8d08f2337d357ec07432ae03382a613dae81c2c226b218e59141be08432b56c9.jpeg",
  internalDoors: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/1b5a5579df62d694197b3ba5c211141ddaffdddf1abe65927f96249641189b0b.jpeg",
  archedDoors: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/9b16d0ccf9fe65c5098a7972936e619484bdc09a138840a09fef6b54355ca2f1.jpeg",
  shopfront: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/b05563dfd20c1f5848f4dfdbce96f28e707216c8441fd4ef6298176304aa84a8.jpeg",
  commercialDoors: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/d35bf90c413adfd92741129b01c0cda957459db8cb79c5d9ac3735ec2455c60b.jpeg",
  powderCoating: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/30c00d527c3ee0442be28d998c52919b6f452d2380a09aaf7d5a1b61f5da7714.jpeg",
  curtainWalling: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/0313a619a11ee412049fead6ac922c55303645617c33f4b9d89e19b7f84a557b.jpeg",
  commercialWindows: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/23412e6e9e5a85054aa72a6785395800d54fed73a5f35c7f4611fc6b3ca6e8c3.jpeg",
  panicExitDoor: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/d0716840d85309747bd855b7cd13f3745f2b1e57990a641aada2fbe338047f33.jpeg",
  residentialSemi: "https://static.prod-images.emergentagent.com/jobs/0fc0a623-208e-4f70-8077-53a04bc0365f/images/2f6bd4e0af966cb2896224dcb4ec9d78c4f6363dd90fcdeb304b4f69139d2cc5.jpeg",
};

export const PARTNERS = [
  {
    id: "comar",
    name: "Comar Architectural Aluminium Systems",
    logo: "/logos/comar.png",
    url: "https://www.comar-alu.co.uk",
    blurb: "Premium British systems house — 5P.i advanced windows, 7P.i doors and 6EFT curtain walling for commercial-grade performance.",
  },
  {
    id: "senior",
    name: "Senior Architectural Systems",
    logo: "/logos/senior.png",
    url: "https://www.seniorarchitectural.co.uk",
    blurb: "The UK's largest privately-owned systems company — SPD150 doors, SF52 curtain walling and the patented PURe range.",
  },
  {
    id: "exlabesa",
    name: "Exlabesa",
    logo: "/logos/exlabesa.svg",
    url: "https://exlabesa.com/en/",
    blurb: "European extrusion leader — high-performance residential windows and doors at cost-effective prices.",
  },
];

export const ACCREDITATIONS = [
  { name: "FENSA Approved", logo: "/logos/fensa.jpg" },
  { name: "SafeContractor Approved", logo: "/logos/safecontractor.svg" },
  { name: "Constructionline Gold Member", logo: "/logos/constructionline.png" },
  { name: "Social Value", logo: "/logos/socialvalue.svg" },
  { name: "Builders Profile", logo: null },
];

export const POWDER = {
  supplier: "Paramount Powders",
  chartUrl: "https://www.paramountpowders.co.uk/colour-charts/ral-colour-chart",
  stock: [
    { name: "Jet Black · RAL 9005", hex: "#0E0E10" },
    { name: "Traffic White · RAL 9016", hex: "#F1F0EA" },
    { name: "Anthracite Grey · RAL 7016", hex: "#383E42" },
  ],
  finishes: ["Gloss", "Matt", "Semi-Gloss"],
};
